<template>
  <div>
    <ejs-dropdownbutton
      v-if="hasTemplate && subject"
      :items="items"
      css-class="e-caret-hide grid-action p-0"
      :select="onSelect"
      :open="onOpen"
    >
      <font-awesome-icon
        :icon="['fas', 'ellipsis-v']"
        size="sm"
      />
    </ejs-dropdownbutton>
    <span
      v-if="!hasTemplate || !subject"
      class="disabled-ellipsis"
    >
      <font-awesome-icon
        :icon="['fas', 'ellipsis-v']"
        size="sm"
      />
    </span>
  </div>
</template>

<script>
import { iframeParentCommunication } from '../../mixins/iframeParentCommunication'

export default {
  mixins: [iframeParentCommunication],
  data () {
    return {
      items: [
        { text: 'Preview', id: 'preview' },
        { text: 'Quick Send', id: 'quickSend' }
      ],
      hasTemplate: false,
      subject: null
    }
  },
  mounted () {
    this.hasTemplate = this.$parent.$parent.campaign.summaryDetails.hasTemplate
    this.subject = this.$parent.$parent.campaign.summaryDetails.subject
  },
  methods: {
    onSelect (args) {
      if (this.$route.query.campaignId) {
        const message = {
          action: '',
          value: {
            projectId: this.$route.query.campaignId,
            customerId: this.data.customerId,
            emailAddress: this.data.email,
            stayID: this.data.stayID
          }
        }
        if (args.item.text === 'Preview') {
          message.action = 'eIn_preview_customer'
        } else if (args.item.text === 'Quick Send') {
          message.action = 'eIn_quick_send_customer'
        } else {
          message.action = ''
        }
        if (message.action) {
          this.SendMessageToParent(message)
        }
      }
    },
    onOpen (args) {
      args.element.parentElement.style.marginLeft = '-20px'
    }
  }
}
</script>

<style lang="scss" scoped>
  .disabled-ellipsis {
    font-size: 1.6rem;
    line-height: 16px;
    padding: 0;
    color: #afafaf;
  }
</style>
